import api from "../api";

export interface City {
  createdAt?: string;
  drivers: string;
  featured: boolean;
  hidden: boolean;
  id: number | string;
  imageAlt?: number | readonly string[] | string | undefined;
  imageAltText: string;
  imageUrl: string;
  isActive?: any;
  launchQuarter?: string;
  name: string;
  order?: number;
  popularAreas?: any;
  province: string;
  residents?: any;
  residentsCount: string;
  restaurants: string;
  services?: any;
  servicesAvailable: string[];
  sinceYear: string;
  statistics?: any;
  status: string;
  totalRides: string;
  unit: string;
  updatedAt?: string;
  updatedBy?: string;
}

function fromBackendPayload(city: any): City {
  return {
    createdAt: city.created_at,
    drivers: city.drivers,
    featured: !!city.featured,
    hidden: !!city.hidden,
    id: city.id,
    imageAltText: city.image_alt_text,
    imageUrl: city.image_url,
    name: city.name,
    province: city.province,
    residentsCount: city.residents_count,
    restaurants: city.restaurants,
    servicesAvailable: city.services_available || [],
    sinceYear: city.since_year,
    status: city.status,
    totalRides: city.total_rides,
    unit: city.unit,
    updatedAt: city.updated_at,
    updatedBy: city.updated_by,
  };
}

function toBackendPayload(city: City) {
  return {
    drivers: city.drivers,
    featured: city.featured,
    hidden: city.hidden,
    image_alt_text: city.imageAltText,
    image_url: city.imageUrl,
    name: city.name,
    province: city.province,
    residents_count: city.residentsCount,
    restaurants: city.restaurants,
    services_available: city.servicesAvailable,
    since_year: city.sinceYear,
    status: city.status,
    total_rides: city.totalRides,
    unit: city.unit,
  };
}

export const CitiesService = {
  create: async (city: City): Promise<City> => {
    const res = await api.post("/cities", toBackendPayload(city));
    return fromBackendPayload(res.data.city);
  },

  delete: async (id: number | string): Promise<void> => {
    await api.delete(`/cities/${id}`);
  },

  getAll: async (): Promise<City[]> => {
    const res = await api.get("/cities");
    return (res.data.cities || []).map(fromBackendPayload);
  },

  getById: async (id: number | string): Promise<City> => {
    const res = await api.get(`/cities/${id}`);
    return fromBackendPayload(res.data.city);
  },

  hide: async (id: number | string): Promise<void> => {
    await api.post(`/cities/${id}/hide`);
  },

  unhide: async (id: number | string): Promise<void> => {
    await api.post(`/cities/${id}/unhide`);
  },

  update: async (id: number | string, city: City): Promise<City> => {
    const res = await api.post(`/cities/${id}`, toBackendPayload(city));
    return fromBackendPayload(res.data.city);
  },
};
